import React from 'react';

import {
  Button,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Grid,
} from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const handleReload = () => {
  globalThis.location.reload();
};

export const UnderMaintenance = () => {
  const [themeMode, setThemeMode] = React.useState<'light' | 'dark'>('light');

  const theme = React.useMemo(() => {
    return createTheme({
      palette: {
        mode: themeMode,
      },
    });
  }, [themeMode]);

  React.useEffect(() => {
    const savedThemeState = localStorage.getItem('theme') as
      | 'light'
      | 'dark'
      | null;
    setThemeMode(savedThemeState ?? 'dark');
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className='d-flex vh-100 justify-content-center align-items-center'>
        <Grid
          container
          sx={{
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100hw',
            height: '100vh'
          }}>
          <Card sx={{ width: '400px' }}>
            <CardMedia
              component='img'
              image='https://storage.yandexcloud.net/site-assets/under_maintanance.png'
            />
            <CardContent>
              <Typography>Сайт обновляется</Typography>
              <Typography>Ведутся работы на сайте. Приходите позже.</Typography>
              <Button
                variant='contained'
                fullWidth
                onClick={handleReload}
                sx={{ marginTop: 2 }}
                data-testid='under-maintenance-reload-button'
              >
                Обновить страницу
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </div>
    </ThemeProvider>
  );
};
